import AutocompleteComponent from './autocomplete/autocomplete'
import DatepickerComponent from './datepicker/datepicker'
import ExpandToggleComponent from './expand-toggle/expand-toggle'
import ExternalAnchorComponent from './external-anchor/external-anchor'
import FormConditionalElementComponent from './form-conditional-element/form-conditional-element'
import FormValidatorComponent from './form-validator/form-validator'
import HashAnchorComponent from './hash-anchor/hash-anchor'
import HashAnchorNavComponent from './hash-anchor-nav/hash-anchor-nav'
import MaterialIconsComponent from './material-icons/material-icons'
import QueryFiltersComponent from './query-filters/query-filters'
import ProgressiveTextTableComponent from './progressive-text-table/progressive-text-table'
import PollReleaseLegacyComponent from './poll-release-legacy/poll-release-legacy'
import SelectComponent from './select/select'
import StickyBarComponent from './sticky-bar/sticky-bar'
import TableStickyColumnComponent from './table-sticky-column/table-sticky-column'

export const Components = {
    PollReleaseLegacyComponent,
    ProgressiveTextTableComponent,
    ExternalAnchorComponent,
    StickyBarComponent,
    ExpandToggleComponent,
    HashAnchorNavComponent,
    HashAnchorComponent,
    FormValidatorComponent,
    FormConditionalElementComponent,
    DatepickerComponent,
    QueryFiltersComponent,
    MaterialIconsComponent,
    SelectComponent,
    AutocompleteComponent,
    TableStickyColumnComponent
}
